import SubnetRow from "./SubnetRow";
import { useTranslation } from "utilities/i18n";
import { PolyIcon } from "elements";
import { ExpandableCard } from "collections/Cards";
import { PrivateSubnet, SubnetMap } from "./Types";
import { FieldArray, useFormikContext } from "formik";
import { validateManually } from "./SubnetHelpers";

const PublicSubnet: React.FC<{
  ruleId: string;
  publicCidr: string;
  fieldName: string;
  index: number;
  isEditable: boolean;
  privateSubnets: Array<PrivateSubnet>;
  remove: (i: number) => void;
  siteId: string;
}> = ({
  ruleId,
  publicCidr,
  fieldName,
  index,
  isEditable,
  privateSubnets,
  remove,
  siteId
}) => {
  const { errors, setErrors } = useFormikContext<SubnetMap>();
  const { t } = useTranslation();
  return (
    <ExpandableCard
      collapsedContent={
        <div className="form-group">
          <SubnetRow
            cidr={publicCidr}
            fieldName={fieldName}
            shouldValidate={privateSubnets.length === 0}
            index={index}
            isEditable={isEditable}
            isPublic={true}
            remove={remove}
            subnetRule={{
              ruleId: ruleId,
              siteId: siteId,
              publicCidr: publicCidr,
              privateCidr: null
            }}
          />
        </div>
      }
      dropdown
      expanded
      styling={["blank", "m-0", "p-0"]}
    >
      <div className="p-0 col-12">
        <FieldArray name={`publicSubnets[${index}].privateSubnets`}>
          {arrayHelpers => (
            <>
              {privateSubnets.map(({ ruleId, cidr: privateCidr }, i) => {
                const validatePrivateSubnet = (i: number) => {
                  validateManually(
                    arrayHelpers.remove,
                    errors,
                    setErrors,
                    index,
                    i,
                    false
                  );
                };
                return [
                  <div key={"subnet-wrapper-" + i} className="form-group">
                    <SubnetRow
                      fieldName={`${arrayHelpers.name}[${i}]`}
                      index={i}
                      isEditable={isEditable}
                      isPublic={false}
                      cidr={privateCidr}
                      key={ruleId}
                      remove={validatePrivateSubnet}
                      subnetRule={{
                        ruleId,
                        siteId: siteId,
                        publicCidr: publicCidr,
                        privateCidr: privateCidr
                      }}
                    />
                  </div>
                ];
              })}
              {isEditable && (
                <div className="grid">
                  <button
                    type="button"
                    className="btn-poly-icon text-left p-0 col-3 offset-2"
                    onClick={() =>
                      arrayHelpers.push({
                        ruleId: "new-" + (privateSubnets.length ?? 0),
                        cidr: ""
                      })
                    }
                  >
                    <PolyIcon icon="plus_circle" className="icon-add mr-5" />
                    <div className="add-label">{t("ADD_PRIVATE_SUBNET")}</div>
                  </button>
                </div>
              )}
            </>
          )}
        </FieldArray>
      </div>
    </ExpandableCard>
  );
};

export default PublicSubnet;
